import url from '@/utils/url'
import hasMixin from '@/mixins/has-mixin'

export default {
  mixins: [hasMixin],
  computed: {
    splitRouteName() {
      return this.$route.name.split('.')
    },
  },
  methods: {
    setOwner(data) {
      this.fields.owner_id = data.id
      this.fields.owner_obj = data
      if (this.splitRouteName[0] !== 'msn') {
        this.fields.owner = data
      }
    },
    deleteOwner() {
      this.fields.owner_id = null
      this.fields.owner_obj = null
      if (this.splitRouteName[0] !== 'msn') {
        this.fields.owner = null
      }
    },
  },
  mounted() {
    let prevRoute = url.getRoute(this.$route)
    if (prevRoute.params.owner_id) {
      this.fields.owner_id = prevRoute.params.owner_id
      this.fields.owner_obj = {
        id: prevRoute.params.owner_id,
        org_full_name: prevRoute.params.org_full_name,
      }
      if (this.splitRouteName[0] !== 'msn') {
        this.fields.owner = {
          id: prevRoute.params.owner_id,
          org_full_name: prevRoute.params.org_full_name,
        }
      }
    }
    this.fields.owner_id = this.fields.owner_obj?.id
  },
}
